import React from 'react';
import I18n from '../../blocks/localization';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import icon_penalty_pay from '../../assets/icons/2x/penalty_pay_48px.png';
import RoutesConst from '../../blocks/consts/RoutesConst';
import ContentLayout from '../core/ContentLayout';
import { ResponseCode } from '../../models/order/ResponseCode';
import PrometInfoIconBox from '../shared/PrometInfoIconBox';


interface Props {
    responseCode: ResponseCode;
}

export function PenaltyPayInfo(props: Props) {

    const history = useHistory();

    const redirect = (route: string) => {
        history.push(route);
    }

    const getText = (): string => {
        switch (props.responseCode) {
            case ResponseCode.Ok:
                return I18n.t('penaltyPay.info.successText');
            case ResponseCode.Canceled:
                return I18n.t('penaltyPay.info.cancelText');
            case ResponseCode.Error:
                return I18n.t('penaltyPay.info.errorText');
        }
    }
    
    return (
        <ContentLayout titleTranslateId='penaltyPay.info.title'>
            <PrometInfoIconBox icon={icon_penalty_pay} content={getText()} />

            <Row>
                <Col xl={12}>
                    <Button type="button" color="primary" className="mr-3 mb-3" outline onClick={() => redirect(RoutesConst.Home)}>{I18n.t('penaltyPay.info.returnToHome')}</Button>
                    {
                        props.responseCode !== ResponseCode.Ok &&
                        <Button type="button" color="primary" className='mb-3' outline onClick={() => redirect(RoutesConst.PenaltyPay)}>{I18n.t('penaltyPay.info.tryAgain')}</Button>
                    }
                </Col>
            </Row>
        </ContentLayout>
    );
}